import { baggageRules } from './definitions';

const combinationValidRecursively = (comb, predicate) => {
  if (!predicate(comb.option)) {
    return false;
  }

  if (!comb.next_leg_options?.length) {
    return true;
  }

  return comb.next_leg_options.some(next =>
    combinationValidRecursively(next, predicate)
  );
};

const hasMatchingCombination = (result, predicate) =>
  result.combinations.some(comb =>
    combinationValidRecursively(comb, predicate)
  );

const filterValidCombinationsRecursively = (combinations, predicate) => {
  if (!combinations?.length) return [];

  return combinations
    .map(comb => {
      const filteredNext = Array.isArray(comb.next_leg_options)
        ? filterValidCombinationsRecursively(comb.next_leg_options, predicate)
        : comb.next_leg_options;

      if (
        combinationValidRecursively(
          { ...comb, next_leg_options: filteredNext },
          predicate
        )
      ) {
        return { ...comb, next_leg_options: filteredNext };
      }

      return null;
    })
    .filter(Boolean);
};

export const baggageCustomFilter = (searchResults, baggageSelected) => {
  const predicate = baggageRules[baggageSelected];
  if (!predicate) return [...searchResults];

  return searchResults
    .map(result => {
      if (!hasMatchingCombination(result, predicate)) return null;

      const filteredCombinations = filterValidCombinationsRecursively(
        result.combinations,
        predicate
      );

      return filteredCombinations.length > 0
        ? { ...result, combinations: filteredCombinations }
        : null;
    })
    .filter(Boolean);
};
